import { Languages, PhoneOutgoing, Wrench, ShieldCheck } from 'lucide-react';

/**
 * Optional add-ons grid + "no lock-in" trust line. Display-only — add-on and
 * outbound billing is not wired up yet, so prices are framed as "talk to us"
 * rather than self-serve checkout. Reduced-motion-safe (static).
 */
const ADD_ONS = [
  {
    icon: Wrench,
    title: 'Done-for-you setup',
    body: 'We build your knowledge base, configure transfers, and go live with you.',
  },
  {
    icon: Languages,
    title: 'Multilingual agent',
    body: 'Answer voice and chat in additional languages on the same knowledge base.',
  },
  {
    icon: PhoneOutgoing,
    title: 'Outbound minutes',
    body: 'Add outbound calling for follow-ups and reminders, billed per minute.',
  },
];

export function AddOnsSection(): JSX.Element {
  return (
    <section className="container py-14 sm:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
          Add-ons when you need them
        </h2>
        <p className="mt-4 text-muted-foreground">
          Start simple, extend as you grow. Every add-on is optional.
        </p>
      </div>

      <div className="mx-auto mt-12 grid max-w-4xl gap-6 sm:grid-cols-3">
        {ADD_ONS.map(({ icon: Icon, title, body }) => (
          <div key={title} className="rounded-xl border border-border bg-card p-6 shadow-sm">
            <Icon className="h-6 w-6 text-primary" aria-hidden="true" />
            <h3 className="mt-4 font-semibold">{title}</h3>
            <p className="mt-1 text-sm text-muted-foreground">{body}</p>
          </div>
        ))}
      </div>

      <div className="mx-auto mt-10 flex max-w-2xl items-center justify-center gap-2 text-center text-sm text-muted-foreground">
        <ShieldCheck className="h-4 w-4 flex-shrink-0 text-emerald-500" aria-hidden="true" />
        <span>No lock-in contracts — month-to-month, cancel anytime.</span>
      </div>
    </section>
  );
}
